<template>
    <v-card class="mt-3">
        <v-list-item class="my-0 title__stys">
            <v-list-item-content class="mt-0 white--text title__sty">
                {{$t('ProductPayType_title1')}}
            </v-list-item-content>
        </v-list-item>
        <v-list-item class="subtitle__stys">
            <v-list-item-content class="white--text title__sty">
                {{$t('ProductPayType_title2')}}
            </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
            <v-radio-group v-model="PayradioGroup" @change="onPayTypeChange($event)">
                <v-radio
                    v-for="(item, idx) in this.$store.state.payment.paymentData"
                    :key="'A' + idx"
                    :label="item.pay_method"
                    :value="item.pay_id"
                    v-show="item.is_support"
                    class="radio__sty"
                ></v-radio>
            </v-radio-group>
        </v-list-item>
    </v-card>
</template>

<script>
    export default {
        name: 'ProductPayType',
        props: [],

        data: () => ({
            PayradioGroup: 6,
        }),
        methods: {
            onPayTypeChange(event) {
                this.$store.state.paytype = parseInt(event);
            },
            initPayType() {
                this.$store.state.paytype = this.PayradioGroup;
            }
        },
        mounted() {
            this.initPayType();
        }
    }
</script>

<style scoped lang="sass">
    .title__stys
        background-color: #352D40
    .subtitle__stys
        background-color: #BDBDBD
    .title__sty
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
</style>
